import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CheckCircleTwoTone, CloseCircleTwoTone, EditOutlined, ReloadOutlined } from '@ant-design/icons';
import { Modal, Tooltip, Tag, Button, Select, Badge } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { cleanObject, stripHtml, formatLastSeen } from '@/utils/helpers';
import { checkPermission } from '@/utils/permission';
import TextTruncate from 'react-text-truncate';
import ReactHtmlParser from 'react-html-parser';
import { getAllUsers, getUser, removeUsers } from '@/redux/actions/userActions';
import UserForm from './UserForm';
import UserDetail from './UserDetail';
import BaseSelect from '@/components/Elements/BaseSelect';
import DynamicTable from '@/components/DynamicTable';
import CustomAvatar from '@/components/CustomAvatar';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/users',
        breadcrumbName: 'Nhân viên',
    },
]

class UserList extends Component {
    state = {
        isLoading: false, // loading table
        selectedRowKeys: [], // id of selected rows
        isOpenUserForm: false,
        currentUser: null,
        isOpenDetail: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query.page = 1;
        query = cleanObject(query); // remove empty fields

        this.props.history.push({
            pathname: '/users',
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));

        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order == 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: '/users',
            search: qs.stringify(query)
        });

    }

    toggleOpenForm(isOpenUserForm, user = null) {
        this.setState({ isOpenUserForm: isOpenUserForm, currentUser: user });
    }

    onEdit(id) {
        this.props.getUser(id).then(user => {
            this.toggleOpenForm(true, user);
        })
    }

    onRemove() {
        this.props.removeUsers(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });

            Modal.destroyAll();
        })
    }

    onDetail(id) {
        this.props.getUser(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentUser: data });
    }

    loadData(query = null) {
        this.setState({ isLoading: true });
        this.props.getAllUsers(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    render() {
        var { users, pagination, config } = this.props;
        var { isLoading, selectedRowKeys, isOpenUserForm, currentUser, isOpenDetail } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                sorter: true,
                width: '50px'
            },
            {
                title: '#',
                align: 'center',
                key: 'action',
                width: '50px',
                render: (text, record) => (
                    <div>
                        <EditOutlined onClick={() => this.onEdit(record.id)} className='color-primary' style={{ fontSize: '15px' }} />
                    </div>
                )
            },
            {
                title: 'Họ và tên',
                dataIndex: 'full_name',
                key: 'full_name',
                sorter: true,
                render: (text, record) => {
                    if (record.full_name) {
                        return (
                            <div onClick={() => this.onDetail(record.id)}>
                                <CustomAvatar name={record.full_name} avatarUrl={record.avatar_url} />
                                &nbsp;<span className='color-primary item-action-btn'>{record.full_name}</span>
                            </div>
                        )
                    } else {
                        return <>N/A</>
                    }
                }
            },
            {
                title: 'Tên đăng nhập',
                dataIndex: 'username',
                key: 'username',
                render: (text, record) => (
                    <Tag>{text}</Tag>
                ),
                sorter: true
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: 'Số điện thoại',
                dataIndex: 'phone',
                key: 'phone'
            },
            {
                title: 'Nhóm',
                dataIndex: ['user_role', 'name'],
                key: 'user_role_name',
                render: (text) => (
                    <>{text}</>
                ),
            },
            {
                title: 'Cơ sở làm việc chính',
                dataIndex: 'primary_branches',
                key: 'primary_branches',
                width: 200,
                render: (branches) => {
                    if (!branches || branches.length === 0) {
                        return <>-</>;
                    }

                    return (
                        <>
                            {branches.map(branch => (
                                <Tag key={branch.id} color="blue">
                                    {branch.name}
                                </Tag>
                            ))}
                        </>
                    );
                }
            },
            {
                title: 'Online',
                dataIndex: 'last_seen',
                key: 'online_status',
                width: 130,
                render: (value) => {
                    const { text, tooltip, isOnline } = formatLastSeen(value);

                    return (
                        <Tooltip placement="left" title={tooltip}>
                            <Badge
                                style={{ transform: 'scale(1.4)', marginRight: 6 }}
                                status={isOnline ? 'processing' : 'default'}
                            />
                            <span style={{ fontSize: 12, color: isOnline ? '#52c41a' : '#666' }}>
                                {text}
                            </span>
                        </Tooltip>
                    );
                },
            },
            {
                title: 'Trạng thái',
                dataIndex: 'is_active',
                key: 'is_active',
                align: 'center',
                render: (text, record) => {
                    if (text == 1) return <CheckCircleTwoTone twoToneColor="#52c41a" />;
                    if (text == 0) return <CloseCircleTwoTone twoToneColor="#e74c3c" />;
                }
            },
            {
                title: 'Đóng bảo hiểm',
                dataIndex: 'insurance_status',
                key: 'insurance_status',
                align: 'center',
                width: 190,
                render: (value) => Number(value) === 1
                    ? <Tag color="green">Có đóng bảo hiểm</Tag>
                    : <Tag>Không đóng bảo hiểm</Tag>
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text) => (
                    <div style={{ wordBreak: "break-word" }}>
                        <Tooltip overlayInnerStyle={{ width: '300px' }} title={ReactHtmlParser(text)}>
                            <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                        </Tooltip>
                    </div>
                )
            }
        ];

        const tables = <DynamicTable
            dataSource={users || []}
            columns={columns}
            isLoading={isLoading}
            pagination={pagination}
            rowSelection={rowSelection}
            moduleKey="users_list"
            onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
        />

        return (
            <div>
                <PageTitle
                    title="Nhân viên"
                    routes={routes}
                />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('user', 'create')}
                        isShowDeleteButton={checkPermission('user', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <Select
                            allowClear
                            className='table-button'
                            placeholder="Nhóm"
                            options={config.role_trees || []}
                            onChange={(value) => this.onChangeFilter('role_id', value)}
                            style={{ width: '200px' }}
                            defaultValue={parseInt(query.role_id) || null}
                        />
                        <BaseSelect
                            placeholder="Trạng thái"
                            style={{ width: '150px' }}
                            onChange={(value) => this.onChangeFilter("is_active", value)}
                            options={[
                                { label: "Active", value: '1' },
                                { label: "Inactive", value: '0' },
                            ]}
                            className="table-button"
                            defaultValue={query.is_active || null}
                        />
                        <BaseSelect
                            placeholder="Hoạt động"
                            style={{ width: '160px' }}
                            onChange={(value) => this.onChangeFilter("online_status", value)}
                            options={[
                                { label: "Đang online", value: "online" },
                                { label: "Đang offline", value: "offline" },
                                { label: "Không rõ", value: "unknown" },
                            ]}
                            className="table-button"
                            defaultValue={query.online_status || null}
                        />
                        <BaseSelect
                            defaultText="Tất cả"
                            placeholder="Đóng bảo hiểm"
                            style={{ width: '250px' }}
                            onChange={(value) => this.onChangeFilter("insurance_status", value)}
                            options={[
                                { label: "Có đóng bảo hiểm", value: "1" },
                                { label: "Không đóng bảo hiểm", value: "0" },
                            ]}
                            className="table-button"
                            defaultValue={query.insurance_status || null}
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>

                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <div className='has-custom-column-table-btn'>
                    {tables}
                </div>
                <UserForm
                    visible={isOpenUserForm}
                    user={currentUser}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <UserDetail
                    visible={isOpenDetail}
                    currentItem={currentUser}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.user.users,
        pagination: state.user.pagination,
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllUsers: (filter) => dispatch(getAllUsers(filter)),
        getUser: (id) => dispatch(getUser(id)),
        removeUsers: (ids) => dispatch(removeUsers(ids))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
